// extracted by extract-css-chunks-webpack-plugin
module.exports = {"logo":"crypto-modal__logo___2I_Ri","header-content":"crypto-modal__header-content___WhTgp","headerContent":"crypto-modal__header-content___WhTgp","hr":"crypto-modal__hr___1OExC","btn":"crypto-modal__btn___2TNBC"};
    if(module.hot) {
      // 1748400839687
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  